// lib/veroeffentlichenPruefen.js — vor „Online stellen" nachsehen, was fehlt (27.09.2026)
//
// Server: GET /api/turniere/:id/vorbereitungsstand (services/vorbereitungsstand.js).
// Fehlt etwas Wesentliches (Datum, Anmeldeschluss, Kategorien, IBAN …), fragt
// die Oberfläche nach, statt still freizuschalten. Ist der Server nicht
// erreichbar, wird nicht blockiert: der Veranstalter soll handeln können.

export async function veroeffentlichenPruefen(turnierId) {
  try {
    const r = await fetch(`/api/turniere/${turnierId}/vorbereitungsstand`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    const d = await r.json();
    if (!r.ok || !d.success) return true;
    const fehlt = d.veroeffentlichen.filter((p) => p.status === 'fehlt');
    const warn = d.veroeffentlichen.filter((p) => p.status === 'warnung');
    if (!fehlt.length && !warn.length) return true;
    const zeile = (p) => `• ${p.titel}: ${p.text}${p.wo ? `\n   → ${p.wo}` : ''}`;
    return window.confirm(
      (fehlt.length ? `Vor dem Veröffentlichen fehlt noch:\n\n${fehlt.map(zeile).join('\n')}\n\n` : '')
      + (warn.length ? `Bitte prüfen:\n${warn.map(zeile).join('\n')}\n\n` : '')
      + 'Trotzdem online stellen?'
    );
  } catch {
    return true;
  }
}
